

jQuery(document).ready(function ($) {

	//link scroller margin (navigating inside page with #)
	var $root = $('html, body');

	$("a[href^='#']").click(function () {
		$root.animate({
			scrollTop: $( $.attr(this, 'href') ).offset().top - 70
		}, 800);

		return false;
	});

});
